import type { FaireAdCampaignEntity } from "../../entity_types/adCampaign";

export const campHbNew: FaireAdCampaignEntity = {
  token: "camp_hb_new",
  type: "adCampaign",
  advertiserProfileToken: "adv_handker_bandanas",
  segment: "NEW_MARKETPLACE",
  status: "RUNNING",
  monthlyBudgetDollars: 2500,
  startedRunningAt: "2026-01-14",
  segmentMetrics: {
    numCustomersAcquired: 194,
    salesDollars: 119506,
    totalAdsSpendDollars: 14548,
    cpaDollars: 87.5,
    bestEstimateSalesDollars: 142338,
    bestEstimateRoas: 9.78,
  },
  performancePeriodTokens: [],
  meta: {
    source: "snowflake",
    importedAt: "2026-09-24T00:00:00.000Z",
    importedBy: "real-brand-data",
  },
};
